import React from 'react'
import { PencilLineIcon } from 'lucide-react'

import { cn } from '@/shared/lib/utils'

export default function InlineEditText({
	className,
	children,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return (
		<div {...props} className={cn('group relative', className)}>
			{children}
			<div className='pointer-events-none invisible absolute top-2 right-0 flex items-center pr-3 group-focus-within:hidden group-hover:visible'>
				<PencilLineIcon className='size-4' />
			</div>
		</div>
	)
}
